import { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import StatusIndicator from '../shared/StatusIndicator';

export type InvitationStatus = 'ACCEPTED' | 'EXPIRED' | 'PENDING';
export interface InvitationStatusBadgeProps {
    status: InvitationStatus;
}

// Todo: add translations.
const statusToTextMap = {
    ACCEPTED: 'Accepted',
    EXPIRED: 'Expired',
    PENDING: 'Pending',
} as const;

const statusToColorClassMap = {
    ACCEPTED: 'success',
    EXPIRED: 'error',
    PENDING: 'warning',
} as const;

const InvitationStatusBadge: FC<InvitationStatusBadgeProps> = (props) => {

    const { t } = useTranslation();

    if (props.status === 'ACCEPTED') {
        return <div aria-valuetext={props.status} aria-label='invitation status'></div>;
    }

    // t('`StatusBadgeWrapper.status_Pending')
    // t('`StatusBadgeWrapper.status_Expired')
    // t('`StatusBadgeWrapper.status_Declined')
    // t('`StatusBadgeWrapper.status_Accepted')
    const statusText = t(`StatusBadgeWrapper.status_${statusToTextMap[props.status]}`, statusToTextMap[props.status]);

    return (
        <StatusBadgeWrapper>
            <StatusIndicator statusClass={statusToColorClassMap[props.status]} aria-label='status indicator'/>
            <StatusText aria-valuetext={props.status} aria-label='invitation status'>
                {statusText}
            </StatusText>
        </StatusBadgeWrapper>
    );
};

export default InvitationStatusBadge;

const StatusBadgeWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 20px;
    width: min-content;
    padding: 0 8px;
    background-color:  ${props => props.theme.colors.greyContrastLowest};
    border: solid 1px ${props => props.theme.colors.greyContrastSemiLower};
    border-radius: 50px;
`;

const StatusText = styled.div`
    margin: 4px 0 4px 4px;
    font-size: 10px;
`;
